class ArrayHelper {
  static notNull<T>(value: T | null): value is T {
    return value !== null;
  }
}

export { ArrayHelper };
